module.exports = __webpack_public_path__ + "images/fa-login-bg.jpg";